import { memo } from "react";
import { VehicleActionsProps } from "./types";
import VehicleDeleteAction from "./components/VehicleDeleteAction/VehicleDeleteAction";
import VehicleDocumentationMenu from "./components/VehicleDocumentationMenu/VehicleDocumentationMenu";
import VehicleEditAction from "./components/VehicleEditAction/VehicleEditAction";

const VehicleActions: React.FC<VehicleActionsProps> = (props) => {
  const { vehicleId, isSold, vehicleDetailRef, userWidgets } = props;

  return (
    <div className="flex gap-2">
      {/* Prodano vozilo je arhivirano — podaci se više ne mijenjaju. */}
      {!isSold && <VehicleEditAction vehicleId={vehicleId} />}
      <VehicleDocumentationMenu
        vehicleId={vehicleId}
        isSold={isSold}
        vehicleDetailRef={vehicleDetailRef}
        userWidgets={userWidgets}
      />
      <VehicleDeleteAction vehicleId={vehicleId} />


    </div>
  );
};

export default memo(VehicleActions);